export const LOCATION_IMAGE_SIZE_MOBILE = 1000;
export const LOCATION_IMAGE_SIZE_DESKTOP = 2000;

export const SITE_IMAGE_SIZE_MOBILE = 500;
export const SITE_IMAGE_SIZE_DESKTOP = 1000;
